@if (product()) {
  <div role="button" tabindex="0" (click)="selectProduct()">
    @if (type() === 'column') {
      <div
        class="d-flex flex-column justify-content-center bg-white sm-radius position-relative overflow-hidden cardSize">
        <!-- NOTE :: MAKE OR REVOKE FAVORITE SECTION -->
        <div class="position-relative">
          @if (!disabledFavoriteAction()) {
            <section
              id="favorite-icon"
              class="position-absolute bg-white rounded-circle border z-3 end-0 me-1 mt-1 d-flex justify-content-center align-items-center"
              role="button"
              tabindex="2">
              <!-- @if (!isLoading() && product()) {
                @if (product().is_favorite_product) {
                  <small
                    type="button"
                    (click)="makeFavoriteProducts(product(), $event)"
                    tabindex="0"
                    title="Revoke Favorite">
                    <span class="text-primary">
                      <i class="fa-solid fa-star"></i>
                    </span>
                  </small>
                } @else if (!product().is_favorite_product) {
                  <small
                    type="button"
                    (click)="makeFavoriteProducts(product(), $event)"
                    tabindex="0"
                    title="Make Favorite">
                    <span class="text-primary"
                      ><i class="fa-regular fa-star"></i
                    ></span>
                  </small>
                }
              } @else {
                <span class="text-primary"
                  ><i class="fas fa-spinner fa-pulse"></i
                ></span>
              } -->
            </section>
          }
          @if (product().lookup_image) {
            <div class="imgSize">
              <img
                class="image object-fit-contain"
                [src]="product().lookup_image"
                alt="{{ product().lookup_title }} image" />
            </div>
          } @else if (product().merchant_logo) {
            <div class="imgSize">
              <img
                class="image object-fit-contain"
                [src]="product().merchant_logo"
                alt="{{ product().lookup_title }} image" />
            </div>
          } @else if (
            product() && (!product().lookup_image || !product().merchant_logo)
          ) {
            <div class="bg-secondary imgSize">
              <span class="d-flex justify-content-center">
                <i
                  class="fa-solid fa-mountain-sun fa-3x my-5 text-secondary"></i>
              </span>
            </div>
          }
          <!-- percentage-label -->
          @if (product().payless_client_rate) {
            <div
              class="badge bg-primary d-flex justify-content-center align-items-center text-all-white position-absolute rounded-pill payless-rate">
              <small class="sm-x-small">
                {{ product().payless_client_rate | number }}%</small
              >
              <small i18n class="ms-1">Off</small>
            </div>
          }
        </div>
        <div
          class="d-flex flex-column justify-content-end flex-grow-1 overflow-hidden position-relative p-1 px-2">
          <div
            class="position-absolute bg-primary rounded-circle redConer"></div>

          <small class="fw-bold">
            {{ product().lookup_title }}
          </small>
          <small class="text-secondary text-truncate">
            {{ product().lookup_subtitle }}
          </small>

          @let price = product().price;
          @if (price && price > 0) {
            <b class="text-primary fs-small">
              <mui-amount-visibility
                [alwaysShowAmount]="true"
                [amount]="product().price"
                [currency]="'BIF'" />
            </b>
          }
        </div>
      </div>
    }

    @if (type() === 'row') {
      <div class="d-flex">
        <div class="product-profile bg-secondary sm-radius shadow-sm">
          @if (product().lookup_image) {
            <img
              class="image object-fit-contain"
              [src]="product().lookup_image"
              alt="{{ product().lookup_title }} Profile" />
          } @else {
            <span class="d-flex justify-content-center">
              <i class="fa-solid fa-mountain-sun fa-2x mt-4 text-secondary"></i>
            </span>
          }
        </div>
        <div class="ms-3 d-flex flex-column me-2 text-truncate">
          <small class="fw-bold text-truncate">{{
            product().lookup_title
          }}</small>
          <span class="text-truncate text-secondary">{{
            product().lookup_subtitle
          }}</span>
          <small class="text-truncate">{{
            product().lookup_description
          }}</small>

          @let price = product().price;
          @if (price && price > 0) {
            <b class="text-primary fs-small">
              <mui-amount-visibility
                [alwaysShowAmount]="true"
                [amount]="product().price"
                [currency]="'BIF'" />
            </b>
          }
        </div>
      </div>
    }
  </div>
}
